




































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Const } from '@/const'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { SimpleTextLayer } from '@/model/document2/page/surface/design/layer/simpleTextLayer';
import { TextInfo } from '@/utilityModels/textInfo';
import { UnitHelper } from '@/helper/unitHelper';
import { MathHelper } from '@/helper/mathHelper';
import { UuidHelper } from '@/helper/uuidHelper';
import { StringHelper } from '@/helper/stringHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { FontManager } from '@/model/fontManager/fontManager';
import { DebugHelper } from "@/helper/debugHelper";
import { SimpleTextLayerHelper } from "@/helper/simpleTextLayerHelper";

import { Rectangle } from '@/utilityModels/rectangle';
import { FontFamily } from '../../../../../model/fontManager/fontFamily/fontFamily';
import { Vector2 } from '../../../../../utilityModels/vector2';

@Component({
    components: {
    },
})

// 縦書きはブラウザ間であまりに動作が異なるので、文字ごとに場所を決定する特殊な処理とします
export default class SimpleTextLayerDrawerV extends Vue
{
    // プレースホルダー
    static readonly PLACEHOLDER_OPACITY = 0.5;
     // 文字の高さに対する下線の割合
    static readonly UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT = 1 / 22.0;
    // 文字の高さに対する下線までのスペース
    static readonly UNDERLINE_SPACING_FROM_CHARACTER_HEIGHT = 0;

    @Prop() private layer!: SimpleTextLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;
    @Prop() private isRenderingOnClient!: boolean;
    // 編集面選択に表示されている場合は、キャレットとプレースホルダを表示しないため
    @Prop({ default: false }) private isInEditor! : boolean;

    // 一部ブラウザでは半角文字と全角文字を混在すると、文字描画がずれる問題があるので
    // tspanではなくtextで各文字を別々に描画する必要がある
    private get isDrawSeparately()
    {
        // サーバーレンダリングはOK
        if(this.isRendering && !this.isRenderingOnClient) return false;
        // ブラウザで判定する
        return UserAgentHelper.getBrowser() == "firefox";
    }

    private uuid = "";

    mounted()
    {
        this.uuid = UuidHelper.getUuid();

        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
    }

    @Watch('layer.width')
    onWidthChanged(val: number, oldVal: number)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
    }

    @Watch('layer.height')
    onHeightChanged(val: number, oldVal: number)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
    }

    @Watch('layer.text')
    onTextChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.inEdit')
    onInEditChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.baseTextInfo.fontId')
    onFontIdChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.baseTextInfo.letterSpacing')
    onLetterSpacingChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.baseTextInfo.letterWidth')
    onLetterWidthChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.baseTextInfo.bold')
    onBoldChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.baseTextInfo.italic')
    onItalicChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.lineSpacing')
    onLineSpacingChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.autoSize')
    onAutoSizeChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.autoNewLine')
    onAutoNewLineChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
        this.updateEdittingTextIfNeeded();
    }

    @Watch('layer.prefix')
    onPrefixChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
    }

    @Watch('layer.suffix')
    onSuffixChanged(val, oldVal)
    {
        this.updateAutoFontSizeIfNeeded();
        this.updateAutoNewLineFontSizeIfNeeded();
    }

    private updateAutoFontSizeIfNeeded()
    {
        // テキスト編集中は更新しない
        if(this.layer.inEdit) return;
        // デザイン編集画面では編集面選択で更新しない
        if(!this.isInEditor && this.$route.path == "/DesignEditor") return;

        if(this.layer.autoSize && !this.layer.autoNewLine)
        {
            var text = this.layerText;
            this.layer.autoFontSize = SimpleTextLayerHelper.calcAutoSizeVertical(text, this.$store.getters.fontManager,
                this.layer.baseTextInfo.fontId, this.layer.baseTextInfo.letterSpacing, this.layer.baseTextInfo.letterWidth, this.layer.lineSpacing, this.layer.width, this.layer.height,
                this.getFontWeight(), this.getFontStyle());

            DebugHelper.trace("updateAutoFontSizeIfNeeded[V] : " + this.layer.autoFontSize);
        }
    }

    private updateAutoNewLineFontSizeIfNeeded()
    {
        // テキスト編集中は更新しない
        if(this.layer.inEdit) return;
        // デザイン編集画面では編集面選択で更新しない
        if(!this.isInEditor && this.$route.path == "/DesignEditor") return;

        if(this.layer.autoNewLine)
        {
            if(this.layer.autoSize)
            {
                let text = this.layerText;
                let result = SimpleTextLayerHelper.calcAutoLineSize(text, this.$store.getters.fontManager,
                    this.layer.baseTextInfo.fontId, this.layer.baseTextInfo.letterSpacing, this.layer.baseTextInfo.letterWidth, this.layer.lineSpacing, this.layer.width, this.layer.height,
                    this.getFontWeight(), this.getFontStyle(), true);
                this.layer.autoFontSize = result.fontSize;
                this.layer.autoLineText = result.autoLineText;
                DebugHelper.trace("updateAutoNewLineFontSizeIfNeeded[V] : " + this.layer.autoFontSize);
                DebugHelper.trace(result.autoLineText);
            }
            else
            {
                let text = this.layerText;
                let lines = SimpleTextLayerHelper.getAutoLineTextWithFixedFontSize(
                    text,
                    this.$store.getters.fontManager,
                    this.layer.baseTextInfo.fontSize,
                    this.layer.baseTextInfo.fontId,
                    this.layer.baseTextInfo.letterSpacing,
                    this.layer.baseTextInfo.letterWidth,
                    this.layer.lineSpacing,
                    this.layer.width,
                    this.layer.height,
                    this.getFontWeight(),
                    this.getFontStyle(),
                    true
                );
                this.layer.autoLineText = lines;
                DebugHelper.trace("getAutoLineTextWithFixedFontSize");
                DebugHelper.trace(lines);
            }
        }
    }

    private updateEdittingTextIfNeeded()
    {
        if(this.layer.inEdit)
        {
            let lines = SimpleTextLayerHelper.getAutoLineTextWithFixedFontSize(
                this.layer.text,
                this.$store.getters.fontManager,
                this.layer.autoSize ? this.layer.autoFontSize : this.layer.baseTextInfo.fontSize,
                this.layer.baseTextInfo.fontId,
                this.layer.baseTextInfo.letterSpacing,
                this.layer.baseTextInfo.letterWidth,
                this.layer.lineSpacing,
                this.layer.width,
                this.layer.height,
                this.getFontWeight(),
                this.getFontStyle(),
                true
            );
            this.layer.edittingText = lines;
        }
    }

    private calcTextSize(text, fontSize, fontFamily)
    {
        // IEは縦書きのテキストサイズ計算が狂うので対処
        let isVertical = UserAgentHelper.getBrowser() != "ie";
        return StringHelper.calcTextSizeOnSVGPt(text, fontSize, fontFamily, this.getFontWeight(), this.getFontStyle(), isVertical);
    }

    private get characterInfoArray()
    {
        var array : Array<{
            x : number,
            orgx : number,
            y : number,
            width : number,
            height : number,
            text : string,
            isFirst : boolean,
            isLast : boolean
        }>= [];
        // 改行コードで分離
        var renderingText = this.layer.autoNewLine && this.layer.autoLineText.length > 0 ? this.layer.autoLineText : this.layerText;
        if(this.isInEditor && this.layer.inEdit) renderingText = this.layer.edittingText;
        var lines = renderingText.split('\n');
        // 字間
        var letterSpacing = UnitHelper.convert(this.layer.baseTextInfo.letterSpacing, "pt", "mm");
        letterSpacing *= 100 / this.layer.baseTextInfo.letterWidth;
        letterSpacing *= this.scale;
        // 基準位置X
        var basex = this.layer.x + this.layer.width;
        basex *= this.scale;
        // 基準位置Y
        var basey = this.layer.y;
        basey *= this.scale;
        var fontSize = this.getFontSizeMm() * this.scale;
        var fontManager: FontManager = this.$store.getters.fontManager;
        var fontFamily = fontManager.getSimpleTextFontFamilyName(
            this.layer.baseTextInfo.fontId,
            false
        );

        var curx = basex;
        var cury = basey;

        var lineWidth = 0;
        var lineCharactersHeight = 0;
        // フォントによっては改行がずれるので、オリジナルフォントサイズから改行位置を補正する
        var blSizePt = this.calcTextSize("あ", this.getFontSizePt(), fontFamily);
        var blWidthPt = blSizePt.width;
        var blWidthMm = UnitHelper.convert(blWidthPt, "pt", "mm");

        for(var i = 0; i < lines.length; ++i)
        {
            var line = lines[i];
            var characters = line.split('');
            if(characters.length == 0)
            {
                // 空白行
                lineWidth = blWidthMm * this.scale;
            }
            else
            {
                for(var c = 0; c < characters.length; ++c)
                {
                    var character = characters[c];
                    // 文字サイズ計測
                    var characterSizePt = UserAgentHelper.getBrowser() == "ie" ?
                        blSizePt :
                        this.calcTextSize(character, this.getFontSizePt(), fontFamily);
                    var characterSize =
                    {
                        width : UnitHelper.convert(characterSizePt.width, "pt", "mm") * this.scale,
                        height : UnitHelper.convert(characterSizePt.height, "pt", "mm") * this.scale
                    };
                    if(StringHelper.isHankakuStrictly(character))
                    {
                        let hankakuSize = StringHelper.calcTextSizeOnSVGPt(character, fontSize, fontFamily, this.getFontWeight(), this.getFontStyle());
                        characterSize.width = hankakuSize.height;
                        characterSize.height = hankakuSize.width;
                    }
                    // 行幅更新
                    lineWidth = Math.max(characterSize.width, lineWidth);
                    lineCharactersHeight += characterSize.height * this.layer.baseTextInfo.letterWidth / 100;

                    // ブラウザにより描画位置のずれを補正
                    var deltaX = 0;
                    var deltaY = 0;
                    if(!this.isRendering)
                    {
                        if(UserAgentHelper.getBrowser() == "safari" && !StringHelper.isHankakuStrictly(character))
                        {
                            deltaY = -characterSize.height / 4;
                        }
                    }
                    if(UserAgentHelper.getBrowser() == "ie")
                    {
                        deltaX = -characterSize.width / 2;
                        deltaY = characterSize.height;
                    }

                    // プロポーショナルフォント対応
                    deltaX -= (blWidthMm * this.scale - characterSize.width) / 2;

                    array.push({
                        x : curx - characterSize.width / 2 + deltaX,
                        orgx : curx,
                        y : cury + deltaY,
                        width : characterSize.width,
                        height : characterSize.height,
                        text : character,
                        isFirst : c == 0,
                        isLast : c == characters.length - 1
                    });

                    // 文字進め
                    cury += characterSize.height;
                    if(this.layer.horizontalAlignment != 3) cury += letterSpacing;
                }

                // 均等揃え
                if(this.layer.horizontalAlignment == 3 && characters.length >= 2)
                {
                    // 均等にした場合の字間を求める
                    var equalLetterSpacing = (this.layer.height * this.scale - lineCharactersHeight) / (characters.length - 1);
                    equalLetterSpacing *= 100 / this.layer.baseTextInfo.letterWidth;

                    var temp = 0;
                    var startIndex = array.length - characters.length;
                    for(var c = startIndex; c < array.length; ++c)
                    {
                        var info = array[c];
                        info.y += temp;
                        temp += equalLetterSpacing;
                    }
                }
                // 中央、終端揃え
                if(this.layer.horizontalAlignment == 1 || this.layer.horizontalAlignment == 2)
                {
                    var lineHeight = lineCharactersHeight + letterSpacing * this.layer.baseTextInfo.letterWidth / 100 * (characters.length - 1);
                    var deltaHeight = this.layer.height * this.scale - lineHeight;
                    if(this.layer.horizontalAlignment == 1) deltaHeight *= 0.5;
                    deltaHeight *= 100 / this.layer.baseTextInfo.letterWidth;
                    var startIndex = array.length - characters.length;
                    for(var c = startIndex; c < array.length; ++c)
                    {
                        var info = array[c];
                        info.y += deltaHeight;
                    }
                }
            }

            // 行進め
            curx -= blWidthMm * this.scale;
            if(i < lines.length - 1) curx -= blWidthMm * this.scale * (this.layer.lineSpacing - 100) / 100;
            cury = basey;
            lineWidth = 0;
            lineCharactersHeight = 0;
        }

        // 列揃え
        if(this.layer.verticalAlignment != 0)
        {
            var deltaWidth = curx - this.layer.x * this.scale;
            if(this.layer.verticalAlignment == 1) deltaWidth *= 0.5;
            for(var i = 0; i < array.length; ++i)
            {
                array[i].x -= deltaWidth;
                array[i].orgx -= deltaWidth;
            }
        }

        return array;
    }

    private get opacity()
    {
        return this.layer.text == "" ? SimpleTextLayerDrawerV.PLACEHOLDER_OPACITY : this.layer.opacity / 100;
    }

    private get layerText()
    {
        var text = "";
        if(this.layer.inEdit)
        {
            // テキスト編集中はプレースホルダ、語頭語尾を表示しない
            text = this.layer.text;
        }
        else if(!this.isInEditor && this.isRendering)
        {
            // レンダリング時とエディタ以外はプレースホルダを表示しない
            text = this.layer.text == "" ? "" : this.layer.prefix + this.layer.text + this.layer.suffix;
            // 全角対応
            if(this.layer.baseTextInfo.isEmQuad) text = StringHelper.toEmQuadString(text);
        }
        else
        {
            text = this.layer.text == "" ? "文字を入力" : this.layer.prefix + this.layer.text + this.layer.suffix;
            // 全角対応
            if(this.layer.baseTextInfo.isEmQuad) text = StringHelper.toEmQuadString(text);
        }

        if(!this.isRendering && UserAgentHelper.getBrowser() == "safari")
        {
            // Safariは縦書き文字になってくれないので補正する
            text = StringHelper.toVerticalStringAll(text);
        }

        return text;
    }

    private get fontSize()
    {
        return this.getFontSizeMm() * this.scale + "px";
    }

    private getFontSizePt()
    {
        return this.layer.autoSize ? this.layer.autoFontSize : this.layer.baseTextInfo.fontSize;
    }

    private getFontSizeMm()
    {
        var fontSize = this.getFontSizePt();
        return UnitHelper.convert(fontSize, "pt", "mm");
    }

    private get fontStyle()
    {
        var style = {
            "font-family" : this.getFontFamily(),
            "font-size" : this.getFontSizeMm() * this.scale + "px",
            "font-weight" : this.getFontWeight(),
            "font-style" : this.getFontStyle(),
            "fill" : this.layer.baseTextInfo.textColor.hex,
            "white-space" : "pre"
        };
        // 縦書き指定
        style["-webkit-writing-mode"] = "vertical-rl";
        style["-ms-writing-mode"] = "tb-rl";
        style["writing-mode"] = "tb-rl";

        return style;
    }

    private getFontFamily() : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var family = fontManager.getSimpleTextFontFamilyName(this.layer.baseTextInfo.fontId, this.isRendering && !this.isRenderingOnClient, this.isRenderingOnClient);
        return family;
    }

    private getFontWeight() : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(this.layer.baseTextInfo.fontId);
        // レイヤーのボールド設定
        var bold = this.layer.baseTextInfo.bold;
        // 太字の代わりに縁取りを使用する場合はboldをfalseとして扱う
        if(FontManager.UseAlternativeOutlineToBold(this.layer.baseTextInfo.fontId)) bold = false;
        // ウェイトがない場合はボールド設定を返す
        if(font.weight == null) { return this.layer.baseTextInfo.bold ? "bold" : "normal"; }
        // レンダリング中はウェイト数値が無効なので、700以上かボールド設定ならボールド、それ以外ならnormalを返す
        if(this.isRendering && !this.isRenderingOnClient) { return (font.weight >= 700 || bold) ? "bold" : "normal"; }
        // ボールド設定がない場合はウェイトを返す
        if(!bold) { return font.weight.toString(); }
        // 700 = bold なので、weightがこの値より大きいならこの値を使い、それ以下のときはboldを指定する。
        return font.weight > 700 ? font.weight.toString() : "bold";
    }

    private getFontStyle() : string
    {
        return this.layer.baseTextInfo.italic ? "italic" : "normal";
    }

    private get transform()
    {
        var transform = "";

        // オフセット
        transform += "translate(" + this.offsetX + " " + this.offsetY + "),";
        // スケール
        transform += "scale(" + this.scale + " " + this.scale + "),";
        transform += "translate(" + this.layer.x + " " + this.layer.y + "),";
        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";
        // 幅・高さによる反転を適用する
        transform += "scale(" + (this.layer.width < 0 ? -1 : 1) + " " + (this.layer.height < 0 ? -1 : 1) + "),";
        // 文字横幅を適用する
        transform += "scale(" + this.layer.baseTextInfo.letterWidth / 100 + " " + 1 + "),";
        transform += "translate(" + (-this.layer.x) + " " + (-this.layer.y) + ")";

        return transform;
    }

    // 縦書きは文字の設定の方でスケーリングしないと、ベースラインがずれる。
    private get noScaleTransform()
    {
        var transform = "";

        // オフセット
        transform += "translate(" + this.offsetX + " " + this.offsetY + "),";
        // スケール
        transform += "translate(" + this.layer.x  * this.scale + " " + this.layer.y  * this.scale + "),";
        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";
        // 幅・高さによる反転を適用する
        transform += "scale(" + (this.layer.width < 0 ? -1 : 1) + " " + (this.layer.height < 0 ? -1 : 1) + "),";
        transform += "translate(" + (-this.layer.x * this.scale) + " " + (-this.layer.y * this.scale) + ")";
        // 文字横幅を適用する
        transform += "translate(" + 0 + " " + (this.layer.y * this.scale) + ")";
        transform += "scale(" + 1 + " " + this.layer.baseTextInfo.letterWidth / 100 + "),";
        transform += "translate(" + 0 + " " + (-this.layer.y * this.scale) + ")";

        return transform;
    }

    private get caretTransform()
    {
        var transform = "";

        // オフセット
        transform += "translate(" + this.offsetX + " " + this.offsetY + "),";

        transform += "translate(" + this.layer.x * this.scale + " " + this.layer.y * this.scale + "),";
        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";
        // 幅・高さによる反転を適用する
        transform += "scale(" + (this.layer.width < 0 ? -1 : 1) + " " + (this.layer.height < 0 ? -1 : 1) + "),";
        transform += "translate(" + (-this.layer.x * this.scale) + " " + (-this.layer.y * this.scale) + ")";

        return transform;
    }

    private get rectTransform()
    {
        var transform = "";

        // オフセット
        transform += "translate(" + this.offsetX + " " + this.offsetY + "),";
        // スケール
        transform += "scale(" + this.scale + " " + this.scale + "),";
        transform += "translate(" + this.layer.x + " " + this.layer.y + "),";
        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";
        // 幅・高さによる反転を適用する
        transform += "scale(" + (this.layer.width < 0 ? -1 : 1) + " " + (this.layer.height < 0 ? -1 : 1) + "),";
        transform += "translate(" + (-this.layer.x) + " " + (-this.layer.y) + ")";

        return transform;
    }

    // キャレットを表示するか
    private get charetVisible()
    {
        // レンダリング中表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }

        return this.layer.inEdit && this.layer.startPosition == this.layer.endPosition;
    }

    private getCharetPos()
    {
        var rectArray = SimpleTextLayerHelper.getRenderingTextRectArrayVertical(this.layer, this.$store.getters.fontManager, this.layer.startPosition, this.layer.startPosition + 1);
        if(rectArray.length == 0)
        {
            return { x1 : 0, y1 : 0, x2 : 0, y2 : 0 };
        }
        var rect = rectArray[0].rect;
        var charetPos = { x1 : rect.x, y1 : rect.y, x2 : rect.x + rect.width, y2 : rect.y };
        if(Math.abs(charetPos.y1 - this.layer.y) < 0.2) { charetPos.y1 = charetPos.y2 = this.layer.y + 0.2; }
        if(Math.abs(charetPos.y1 - (this.layer.y + this.layer.height)) < 0.2) { charetPos.y1 = charetPos.y2 = this.layer.y + this.layer.height - 0.2; }
        return { x1 : charetPos.x1 * this.scale, y1 : charetPos.y1 * this.scale, x2 : charetPos.x2 * this.scale, y2 : charetPos.y2 * this.scale };
    }

    // 選択を表示するか
    private get selectionVisible()
    {
        // レンダリング中表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }

        return this.layer.inEdit && this.layer.startPosition != this.layer.endPosition;
    }

    // 選択領域
    private get selectionRectArray()
    {
        var start = Math.min(this.layer.startPosition, this.layer.endPosition);
        var end = Math.max(this.layer.startPosition, this.layer.endPosition);
        return SimpleTextLayerHelper.getRenderingTextRectArrayVertical(this.layer, this.$store.getters.fontManager, start, end);
    }

    private get shadowOpacity() { return this.layer.baseTextInfo.shadowIntensity / 100; }

    private get shadowFontStyle()
    {
        var style = {
            "font-family" : this.getFontFamily(),
            "font-size" : this.getFontSizeMm() * this.scale + "px",
            "font-weight" : this.getFontWeight(),
            "font-style" : this.getFontStyle(),
            "fill" : this.layer.baseTextInfo.shadowColor.hex,
            "white-space" : "pre"
        };
        // 縦書き指定
        style["-webkit-writing-mode"] = "vertical-rl";
        style["-ms-writing-mode"] = "tb-rl";
        style["writing-mode"] = "tb-rl";

        return style;
    }

    private shiftShadow(x : number, y : number, width : number, height : number)
    {
        var distance = this.getFontSizeMm() * 2 * this.layer.baseTextInfo.shadowDistance / 100;
        var radian = this.layer.baseTextInfo.shadowRotate * Math.PI / 180;
        var xDistance = distance * Math.cos(radian) * this.scale;
        var yDistance = distance * Math.sin(radian) * this.scale;
        return new Vector2(x + xDistance, y + yDistance);
    }

    private get shadowBlueId() { return "shadow_blur_" + this.uuid; }

    private get shadowDiviation()
    {
        return 0.8 * this.layer.baseTextInfo.shadowBlur / 100 * this.scale;
    }

    private get outlineOpacity() { return this.layer.baseTextInfo.outlineIntensity / 100; }

    private get outlineFontStyle()
    {
        var outlineThickness = this.getFontSizeMm() * this.scale * this.layer.baseTextInfo.outlineThickness / 750;
        var style = {
            "font-family" : this.getFontFamily(),
            "font-size" : this.getFontSizeMm() * this.scale + "px",
            "font-weight" : this.getFontWeight(),
            "font-style" : this.getFontStyle(),
            "fill" : "none",
            "stroke" : this.layer.baseTextInfo.outlineColor.hex,
            "stroke-width" : this.alternativeOutlineThickness() + outlineThickness,
            "stroke-linejoin" : "round",
            "white-space" : "pre"
        };
        // 縦書き指定
        style["-webkit-writing-mode"] = "vertical-rl";
        style["-ms-writing-mode"] = "tb-rl";
        style["writing-mode"] = "tb-rl";

        return style;
    }

    private get isVisibleAlternativeOutline() {
        return this.layer.baseTextInfo.bold && FontManager.UseAlternativeOutlineToBold(this.layer.baseTextInfo.fontId);
    }

    private alternativeOutlineThickness() {
        return this.isVisibleAlternativeOutline ? this.getFontSizeMm() * this.scale * 24 / 750 : 0;
    }

    private get alternativeOutlineStyle() {
        var style = {
            "font-family": this.getFontFamily(),
            "font-size": this.getFontSizeMm() * this.scale + "px",
            "font-style": this.getFontStyle(),
            fill: "none",
            stroke: this.layer.baseTextInfo.textColor.hex,
            "stroke-width": this.alternativeOutlineThickness(),
            "stroke-linejoin": "round",
            "white-space": "pre"
        };

        // 縦書き指定
        style["-webkit-writing-mode"] = "vertical-rl";
        style["-ms-writing-mode"] = "tb-rl";
        style["writing-mode"] = "tb-rl";

        return style;
    }

    private get lineInfoArray()
    {
        var array : Array<{
            x : number,
            y : number,
            width : number,
            height : number
        }>= [];

        var y = 0;
        var characterInfoArray = this.characterInfoArray;
        for(var i = 0; i < characterInfoArray.length; ++i)
        {
            var info = characterInfoArray[i];
            if(info.isFirst)
            {
                y = info.y;
            }
            if(info.isLast)
            {
                array.push({
                    x : info.orgx + this.getFontSizeMm() * this.scale * SimpleTextLayerDrawerV.UNDERLINE_SPACING_FROM_CHARACTER_HEIGHT,
                    y : y,
                    width : 1,
                    height : info.y + info.height - y
                });
            }
        }

        return array;
    }

    private get underlineHeight() { return this.getFontSizeMm() * this.scale * SimpleTextLayerDrawerV.UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT; }
}
